/**
 * @fileoverview POST handler for the "/alloys/:partner/attribution/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAlloysPartnerAttributionAppGroupIdCacheKeys } from "./constants";
import type {
  PostAlloysPartnerAttributionAppGroupIdProps,
  PostAlloysPartnerAttributionAppGroupIdResult,
} from "./types";

export const postAlloysPartnerAttributionAppGroupId = reactQueryMutationAdapter(
  postAlloysPartnerAttributionAppGroupIdCacheKeys,
  (props: PostAlloysPartnerAttributionAppGroupIdProps): Promise<PostAlloysPartnerAttributionAppGroupIdResult> => {
    return fetch(`/alloys/${props.partner}/attribution/${props.appGroupId}`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
